import React from "react";

export const HotJarContext = React.createContext();
